import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

interface CartOpenedPayload {
  accountId: string;
}

export class CartOpenedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(public readonly payload: CartOpenedPayload) {
  }
}
